module.exports = __webpack_public_path__ + "img/background_altromercato_concorso_24_mobile.1d00ff54.png";